import i18n from '../i18n';

export default {
  required: i18n.t('form.errors.required'),
  min: i18n.t('form.errors.min'),
  max: i18n.t('form.errors.max'),
  email: i18n.t('form.errors.email'),
  acceptTerms: i18n.t('form.errors.acceptTerms'),
  phone: i18n.t('form.errors.phone'),
  passwordsMatch: i18n.t('form.errors.passwordsMatch'),
  passwordStrength: i18n.t('form.errors.passwordStrength'),
  minOneRoom: i18n.t('form.errors.minOneRoom'),
  minGuests: i18n.t('form.errors.minGuests'),
  maxGuests: i18n.t('form.errors.maxGuests'),
  bookingValid: i18n.t('form.errors.bookingValid'),
  decimalPlaces: i18n.t('form.errors.decimalPlaces'),
};
